import {computed, ref} from 'vue'
import { useStore } from "vuex";
import {
    User, OfficeBuilding, Menu as IconMenu, Setting, Service, Ticket, Trophy, Sugar, ArrowLeftBold
} from '@element-plus/icons-vue'
import store from "@/store";

export default {
    name: 'asideComp',
    components: {
        User,
        OfficeBuilding,
        IconMenu,
        Setting,
        Service,
        Ticket,
        Trophy,
        Sugar,
        ArrowLeftBold
    },
    setup () {

        const store = useStore()
        const userRoles = computed(() => store.getters['basic/userRoles'])

        const isCollapse = ref(true)
        const handleOpen = (key, keyPath) => {
            // console.log(key, keyPath)
        }
        const handleClose = (key, keyPath) => {
            // console.log(key, keyPath)
        }
        const toggle = () => {
            if (isCollapse.value) {
                isCollapse.value = false
            } else {
                isCollapse.value = true
            }
        }
        return {
            isCollapse,
            handleOpen,
            handleClose,
            toggle,
            userRoles,
        }
    },
    data () {
        return {}
    },
    mounted() {
    },
    methods: {
        go(route){
            this.$router.push(route)
        }
    },
    computed: {
        toggleCss () {
            if (this.isCollapse) {
                return {
                    'justify-content': 'flex-end'
                }
            } else {
                return {
                    'justify-content': 'flex-end',
                    padding: '0px 10px'
                }
            }
        },
        isMaster: function (){
            return this.userRoles.includes('ROLE_MASTER')
        },
        isHost: function (){

            const anyRoles = ['ROLE_HOST', 'ROLE_HOST_SUB']

            return this.userRoles.includes('ROLE_HOST')
        },
        isHostSub: function (){
            return this.userRoles.includes('ROLE_HOST_SUB')
        },
        isStore: function (){
            const anyRoles = ['ROLE_HOST', 'ROLE_HOST_SUB']

            return this.userRoles.includes('ROLE_STORE')
        },
        isStoreSub: function (){
            return this.userRoles.includes('ROLE_STORE_SUB')
        },
    }
}
